module.exports = __webpack_public_path__ + "img/ercode.aea3386e.png";